import { api } from '../../lib/api.ts';
import type { Role, ZoneRole } from '../../store/auth.ts';

export interface OrgUserRow {
  id: string; email: string; name: string; nameDv?: string | null; role: Role | null; zoneRole?: ZoneRole | null;
  isOrgAdmin: boolean; isActive: boolean; createdAt: string;
  designationDv: string | null; designationEn: string | null;
}

export type OrgUserPatch = Partial<
  { role: Role } &
  Pick<OrgUserRow, 'isActive' | 'isOrgAdmin' | 'designationDv' | 'designationEn'>
>;

export const usersApi = {
  list: () => api.get<{ users: OrgUserRow[] }>('/users').then((r) => r.data.users),
  update: (id: string, patch: OrgUserPatch) =>
    api.patch<{ user: OrgUserRow }>(`/users/${id}`, patch).then((r) => r.data.user),
  updateMe: (patch: { name?: string }) => api.patch('/users/me', patch).then((r) => r.data),
  changePassword: (current: string, next: string) => api.post('/users/me/password', { current, next }),
  resetPassword: (id: string) => api.post(`/users/${id}/reset-password`),
};
